import { render } from "./UICollapsiblePanel.vue?vue&type=template&id=7a7ec526&scoped=true"
import script from "./UICollapsiblePanel.vue?vue&type=script&lang=js"
export * from "./UICollapsiblePanel.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7a7ec526"

export default script